<template>
  <div class="subscribe-li">
    <template v-if="visible">
      <div class="w-full text-[16px] leading-[20px] mb-[16px]">
        {{ rights.rights_name }}
      </div>
      <StickyButtonView
        class="subscribe-customer-button"
        :class="[
          'subscribe-customer-button__rights-btn',
          `subscribe-customer-button__rights-btn-${rights.rights_type} ${
            !isChinese() && rights.rights_type !== USER_LEVEL_KEY.TASTE
              ? 'rights-en'
              : ''
          }`,
        ]"
      />
    </template>
    <template v-else>
      <span class="text-font-1">{{ rights.rights_name }}</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { getRightsView } from '../rights-view'
import type { LoginInfo } from '~/api/interface'
import type { IEquity } from '~/api/interface/rights'
import { USER_LEVEL_KEY } from '~/api/interface/auth'

const props = defineProps<{
  visible: boolean
  rights: IEquity
  accountList: LoginInfo[]
  colorsMap: any
}>()

const userInfo = useUserInfo()
const overseas = useRightsConfig()

const { StickyButtonView } = getRightsView({
  rights: props.rights,
  userInfo: userInfo.value,
  accountList: props.accountList,
  overseas: isGlobalVersion() ? overseas.value : null,
})
</script>
<style>
.subscribe-customer-button.ant-btn-primary {
  background: linear-gradient(252.56deg, #fff3c9 10.68%, #f6db6f 106.01%);
  color: var(--warning-10);
  border-color: #ffffff;
  &:hover {
    background: linear-gradient(
      252.56deg,
      rgba(255, 243, 201, 0.7) 10.68%,
      rgba(246, 219, 111, 0.7) 106.01%
    );
    color: var(--warning-10);
  }
}
.subscribe-li:last-child {
  .subscribe-customer-button.ant-btn-primary {
    background: #271d0b;
    color: var(--warning-3);
    &:hover {
      background: rgba(39, 29, 11, 0.7);
      color: var(--warning-3);
    }
  }
}
.subscribe-li:first-child {
  .subscribe-customer-button.ant-btn-primary {
    background: #f2f3f3;
    color: var(--text-1);
  }
}
.subscribe-customer-button.ant-btn-primary.ant-btn-background-ghost:not(
    :disabled
  ):hover {
  background-color: transparent;
  color: var(--warning-10);
  border-color: #fff;
}
.subscribe-customer-button {
  &:hover {
    opacity: 0.8;
  }
  &__rights-btn {
    width: 120px;
    height: 32px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
  }
  &__rights-btn-1 {
    background: var(--back-3);
    color: var(--text-1);
  }
  &__rights-btn-3,
  &__rights-btn-10,
  &__rights-btn-16 {
    background: linear-gradient(293deg, #fff3c9 0%, #f6db6f 100%);
    color: var(--warning-10);
  }
  &__rights-btn-24 {
    background: #271d0b;
    color: var(--warning-3);
  }
}
</style>
